import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import React from 'react';

const ObjectSelect = ({ label, helperText, errorText, fullWidth, data = [], value = '', onChange, display, ...other }) => {
  return (<FormControl error fullWidth={fullWidth}>
    {label ? <InputLabel htmlFor="name-error">{label}</InputLabel> : null}
    <Select
      fullWidth={fullWidth}
      value={value ? value.id : ''}
      onChange={(evt) => onChange(data.find((e) => e.id === evt.target.value))}
      name={label}
      {...other}
    >
      {(data || []).map((o) => (<MenuItem key={o.id} value={o.id}>{display(o)}</MenuItem>))}
    </Select>
    {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    {errorText ? <FormHelperText>{errorText}</FormHelperText> : null}
  </FormControl>);
};

export default ObjectSelect;



// WEBPACK FOOTER //
// ./src/components/Common/ObjectSelect/index.js